import { ActivatedRoute, Router } from '@angular/router';
import { ForgotpasswordService } from '../../../../services/admin/forgotpassword.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-responsereset-admin',
  templateUrl: './responsereset-admin.component.html',
  styleUrls: ['./responsereset-admin.component.css']
})
export class ResponseresetAdminComponent implements OnInit {

  public redefinirSenhaForm = this.fb.group({
    password: ['', [Validators.required, Validators.minLength(6)]],
    passwordConfirmacao: ['', [Validators.required, Validators.minLength(6)]],
  });

  public token: any = null;
  public erro: any = null;

  constructor(
    private fb: FormBuilder,
    private forgotPasswordService: ForgotpasswordService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];
    });
  }
  ngOnInit() {
  }

  public redefinir(): void {

    if (this.redefinirSenhaForm.value.password !== this.redefinirSenhaForm.value.passwordConfirmacao) {
      this.forgotPasswordService.toastError('Senhas devem ser iguais !');
    } else {
      const formData = new FormData();
      formData.append('password', this.redefinirSenhaForm.get('password').value);
      formData.append('token', this.token);

      this.forgotPasswordService.resetPassword(formData).subscribe(
        (res: any) => {
          this.router.navigate(['/admin/login']);
          this.forgotPasswordService.toastSuccess('Senha Admin alterada com sucesso !');
        },
        (error: any) => {
          this.erro = error;
          this.forgotPasswordService.toastError('Erro ao alterar senha. Solicite nova recuperação de senha !');
        }
      );
    }
  }
}
